<div class="row entradas-de-texto-govco">
  <legend>
    <h3>CONFIRMACIÓN TÉRMINOS Y CONDICIONES Política de protección y tratamiento de datos personales</h3>
  </legend>
  <label class="">Autorizo en forma previa, expresa e informada como titular de mis datos a la Secretaría Distrital de Salud y el Fondo Financiero Distrital de Salud, para hacer uso y tratamiento de mis datos personales de conformidad con lo previsto en el Decreto 1377 de 2013 que reglamenta la Ley 1581 de 2012.
    Los datos personales serán gestionados de forma segura y algunos tratamientos podrán ser realizados de manera directa o a través de encargados. El tratamiento de los datos personales por parte de la Secretaría Distrital de Salud se realizará dando cumplimiento a la Política de Privacidad y Protección de Datos personales que puede ser consultada en la Política de Protección y Tratamiento de Datos Personales.</label>

  <div class="col-12 col-md-12 pl-4 text-center">
    <div class="col-12">
      <br><br>
      <button (click)="confirmar()" type="button" class="btn-govco fill-btn-govco">
        Confirmar
      </button>
      <br><br>
      <button (click)="noAceptar()" type="button" class="btn-govco fill-btn-govco">
        No aceptar
      </button>
    </div>
  </div>
</div>


